export default __webpack_public_path__ + "static/media/matrixroute.d630960e.png";